import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as Data from '../Data';
import { NavLink, Redirect } from 'react-router-dom';
import { BaseComponent, ChiamaAPI, BottoneAPI, Trad, Tipo, CampoData } from '../components/';
import moment from 'moment';
import {CustomDropzone} from "../components/custom/Dropzone/CustomDropzone";
import {DropEvent} from 'react-dropzone';

interface IFileState {
    Dato: Dati.CRisAPIDatoTipiFile;
    InputFile?: File;
}

export class FileDett extends BaseComponent<Glob.IRouteGlobaleProps, IFileState> { //Aggiunto il suffisso Dett per non sovrascrivere la classe file di lib.d.ts
    private ID_Chiave: number = 0;
    private ID_File: number = 0;

    constructor(props: any) {
        super(props);
        this.state = { Dato: new Dati.CRisAPIDatoTipiFile(), InputFile: undefined };
        this.ID_Chiave = (this.props.match.params as any).ID_Chiave;
        this.ID_File = (this.props.match.params as any).ID_File;
        this.state.Dato.Dato.ID_Chiave = this.ID_Chiave;
        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnChangeDataRilascio = this.OnChangeDataRilascio.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
        this.OnDrop = this.OnDrop.bind(this);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiFile, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (dati.Dato.ID_Chiave > 0) {
                this.setState({ Dato: dati });
                this.ID_Chiave = dati.Dato.ID_Chiave;
                this.ID_File = dati.Dato.ID_File;

                let menu = 0;
                if (dati.Dato.ID_File > 0) {
                    menu = 10;
                }
                var M = Glob.GetMenu();
                M.Main = "Home";
                M.ID_MenuMain = menu;
                this.props.SetMenu(M);
            }
            else {
                this.state.Dato.Tipi = dati.Tipi;
                this.setState({ Dato: this.state.Dato });
            }
        }
        return false;
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        }
        else {
            //if (this.ID_File == 0) {
            //    this.props.history.replace("/file/" + dati.ID_Chiave);
            //}
            //this.props.history.replace("/file/" + (this.props.match.params as any).ID_Chiave);
            //setTimeout(Glob.InfoModaleSuccess("DOCUMENTI", "Documento salvato correttamente"), 500);
            this.props.history.goBack();
        }
    }

    private OnInvioFileSalva(sender: BottoneAPI): any {
        if (this.state.InputFile != undefined) {
            var FD = new FormData();
            FD.append("file", this.state.InputFile);
            FD.append("ingr", JSON.stringify(this.state.Dato));
            return FD;
        }
        else {
            var FD = new FormData();

            FD.append("ingr", JSON.stringify(this.state.Dato));
            return FD;
        }
    }

    private OnInvioFileElimina(sender: BottoneAPI): any {
        class file {
            id_file: number = 0;
            sessione: string = "";
        }
        let result: file = new file();
        result.id_file = this.ID_File;
        return result;
    }


    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
    }

    private OnDrop(accepted: File[],
                   rejectedFiles: File[],
                   event: DropEvent) {
        this.setState({ InputFile: accepted[0] });
    }

    private OnChangeDataRilascio(e: React.FormEvent<any> | string, valore?: any): void {
        this.OnChange(e, valore);
    }

    public render() {
        var caricaDocumento = <CustomDropzone OnDrop={this.OnDrop.bind(this)} AcceptedFiles={""} InputFile={this.state.InputFile}
                                              NoFileMessage={Trad.Trad("CaricaDocumento")}/>
        if (this.ID_File > 0) {
            caricaDocumento = <div>
                <a className="special" target="_blank" href={"/api/file/scarica?id_file=" + this.ID_File + "&sessione=" + Glob.GetSessione().Sessione}>
                    <span className="la la-download"> </span> {Trad.Trad("ScaricaFile")}
                </a>
            </div>;
        }

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-file"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Documenti")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                            <NavLink to={"/file/" + this.ID_Chiave + "/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <div className="col-lg-6">
                            <label>{Trad.Trad("NomeFile")}</label>
                            <input type="text" className="form-control" value={this.state.Dato.Dato.NomeFile} name="Dato.NomeFile" readOnly />
                        </div>
                        <div className="col-lg-6">
                            <label>{Trad.Trad("TipoFileStato")}</label>
                            <Tipo Campo="Dato.ID_TipoFileStato" ID_ChiaveString={this.state.Dato.Dato.ID_TipoFileStato || Glob.Tipi_FS_Caricato} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi["TipiFileStati"]} />
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-4">
                            <label>{Trad.Trad("ID_TipoDocumento")}</label>
                            <Tipo Campo="Dato.ID_TipoFile" ID_ChiaveString={this.state.Dato.Dato.ID_TipoFile} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi["TipiFile"]} />
                        </div>
                        <div className="col-lg-4">
                            <label>{Trad.Trad("TipoDocumento")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control" value={this.state.Dato.Dato.TipoDocumento} name="Dato.TipoDocumento" onChange={this.OnChange} />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <label className="">{Trad.Trad("Numero documento")}</label>
                            <input type="text" className="form-control" value={this.state.Dato.Dato.NumeroDocumento} name="Dato.NumeroDocumento" onChange={this.OnChange} />
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <div className="col-lg-4"><label>
                            {Trad.Trad("Rilasciato da")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control" value={this.state.Dato.Dato.RilasciatoDa} name="Dato.RilasciatoDa" onChange={this.OnChange} />
                                <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                    <span>
                                        <i className="la la-pencil"></i>
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <label className="">{Trad.Trad("Data rilascio")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <div className="form-control">
                                    <CampoData ValoreInArrivo={this.ID_File > 0}
                                        Name="Dato.DataRilascio"
                                        Id="Dato.DataRilascio"
                                        Valore={this.state.Dato.Dato.DataRilascio}
                                        OnChange={this.OnChangeDataRilascio}
                                        DataMassima={this.state.Dato.Dato.DataScadenza} />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <label className="">{Trad.Trad("Data scadenza")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <div className="form-control">
                                    <CampoData ValoreInArrivo={this.ID_File > 0}
                                        Name="Dato.DataScadenza"
                                        Id="Dato.DataScadenza"
                                        Valore={this.state.Dato.Dato.DataScadenza}
                                        OnChange={this.OnChange}
                                        DataMinima={moment().add(-1, "d").toDate()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <div className="col-lg-12">
                            <label>{Trad.Trad("Note")}</label>
                            <div>
                                <textarea rows={4} cols={5} className="form-control kt-input" id="exampleTextarea" value={this.state.Dato.Dato.Note} name="Dato.Note" onChange={this.OnChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-12">
                            {caricaDocumento}
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <ChiamaAPI Aggiornare={1} URL={"/api/file/seleziona?id_File=" + this.ID_File + "&ID_Chiave=" + this.ID_Chiave} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                                    <div className={this.ID_File == 0 ? "divtabella hidden" : "divtabella"}>
                                        <BottoneAPI Testo={Trad.Trad("Elimina")} URL={"/api/file/Elimina?id_file=" + this.ID_File} Metodo="GET" OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} ClasseAttivo="btn btn-danger" ClasseAttesa="btn btn-danger" />
                                    </div>
                                    <div className="divtabella">
                                        <BottoneAPI InviaFile Default Testo={Trad.Trad("Salva")} URL="/api/file/" Metodo="POST" OnInvio={(s) => this.OnInvioFileSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/File.tsx